var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76.002,
    height: 75.829,
    viewBox: "0 0 76.002 75.829",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#A82047;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1 -1.048)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M74.958,34.009l-7.081-7.081V16.875a6.909,6.909,0,0,0-6.909-6.909H50.95L43.869,3.057a6.909,6.909,0,0,0-9.741,0L27.046,10H16.994a6.909,6.909,0,0,0-6.909,6.909V26.927L3.176,34.009A6.723,6.723,0,0,0,3,43.75l7.116,7.081V60.884a6.909,6.909,0,0,0,6.909,6.909H27.046l7.081,7.081a6.922,6.922,0,0,0,9.741,0l7.081-7.116H61a6.909,6.909,0,0,0,6.909-6.909V50.831l7.081-7.081a6.909,6.909,0,0,0,0-9.741ZM60.968,48v12.85H48.118L39,69.969l-9.12-9.12H17.028V48l-9.12-9.12,9.12-9.12V16.909h12.85L39,7.79l9.12,9.12h12.85V29.76l9.12,9.12Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M29.555,8.709,8.829,32.89A3.455,3.455,0,1,0,14.08,37.38L34.806,13.2a3.455,3.455,0,1,0-5.251-4.491Z",
    transform: "translate(17.18 15.834)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.6,17.669a5.182,5.182,0,1,0-6.391-3.454A5.182,5.182,0,0,0,15.6,17.669Z",
    transform: "translate(19.595 15.856)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.76,13.69a5.182,5.182,0,1,0,6.391,3.454A5.182,5.182,0,0,0,15.76,13.69Z",
    transform: "translate(27.038 30.544)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.98068121f9df4a3cef09553212f0aee8.svg";
export { ForwardRef as ReactComponent };